import { FunctionComponentElement, useState } from "react";
import { NodeInputProps } from "../index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InputText } from "primereact/inputtext";
import { v4 as uuidv4 } from "uuid";
import { useDispatch } from "react-redux";
import { setToast } from "../../../app/appSlice";
import {
  selectedTypesTemplate,
  Types,
  TypesOptionTemplate,
} from "../avro/Field";
import { Dropdown } from "primereact/dropdown";
import { FieldType } from "./FieldType";
import CorrespondanceTypeImage from "../avro/correspondanceTypeImage";

export interface IMap {
  id: string;
  key: string;
  value: any;
  type: "boolean" | "string" | "number";
}

export const ArrayToKeyValueObject = (value: IMap[]) => {
  let mapConstruct: any = {};
  for (let item of value) {
    if(item.key !== "")mapConstruct[item.key] = item.value;
  }
  return mapConstruct;
};

export const deduceType = (value: any) => {
  if (typeof value === "boolean") return "boolean";
  if (typeof value === "string") return "string";
  if (typeof value === "number") return "number";
  return "string";
};

export const KeyValueObjectToArray = (values: any) => {
  const objectConstruct: IMap[] = [];
  const map: Map<string, any>  = new Map(Object.entries(values));

  //@ts-ignore
  for (let [key, value] of map) {
    objectConstruct.push({
      key: key,
      value: value,
      id: uuidv4(),
      type: deduceType(value),
    });
  }
  return objectConstruct;
};

export const MapStringAny = ({
  value,
  onChange,
  defaultValue,
  disabled
}: NodeInputProps): FunctionComponentElement<NodeInputProps> => {
  const verifyType = (obj: any) => {
    if (typeof obj !== "object" || obj === null || Array.isArray(obj)) {
      return false;
    }
    const map: Map<string, any> = new Map(Object.entries(obj));
    // Check if all keys and values are strings

    //@ts-ignore
    for (let [key, value] of map) {
      if (typeof key !== "string") {
        return false;
      }
      if (
        typeof value !== "boolean" &&
        typeof value !== "number" &&
        typeof value !== "string"
      ) {
        return false;
      }
    }
    return true;
  };

  const [incorrectDefaultValue, setIncorrectDefaultValue] =
    useState<boolean>(false);

  const [mapWidget, setMapWidget] = useState<IMap[]>(() => {
    if (value) return KeyValueObjectToArray(value);
    else if (defaultValue) {
      const typeVerified = verifyType(defaultValue);
      if (typeVerified) return KeyValueObjectToArray(defaultValue);
      else setIncorrectDefaultValue(true);
    }
    return [];
  });

  const types: Types[] = [
    { name: "Chaine de caractère", type: "string" },
    { name: "Nombre", type: "number" },
    { name: "Booléen", type: "boolean" },
  ];

  const dispatch = useDispatch();

  const [valueType, setValueTypes] = useState<Types>(types[0]);

  const initValueByType = (type: "boolean" | "string" | "number"): any => {
    if (type === "boolean") return true;
    if (type === "string") return "";
    if (type === "number") return 1;
  };

  const addItem = () => {
    if (!valueType) {
      dispatch(
        setToast({
          content: "Veuillez sélectionner un type",
          life: 3000,
          severity: "error",
          title: "Erreur",
        })
      );
    } else {
      const tempItems = Array.from(mapWidget);
      tempItems.push({
        key: "",
        value: initValueByType(valueType.type),
        id: uuidv4(),
        type: valueType.type,
      });
      setMapWidget(tempItems);
      setIncorrectDefaultValue(false);
    }
  };

  const deleteItem = (index: number) => {
    const tempItems = Array.from(mapWidget);
    tempItems.splice(index, 1);
    setMapWidget(tempItems);
    onChange(ArrayToKeyValueObject(tempItems));
  };

  const udpateItem = (index: number, value: IMap) => {
    const tmpItems = Array.from(mapWidget);
    tmpItems[index] = value;
    setMapWidget(tmpItems);
    onChange(ArrayToKeyValueObject(tmpItems));
  };

  return (
    <div className="mt-5 mb-2">
      {incorrectDefaultValue && (
        <div className="error-text">
          La valeur par défaut est incorrecte, veuillez la corriger ou saisir
          une valeur afin de l'écraser
        </div>
      )}
      <div className="grid font-bold">
        <div
          style={{ marginLeft: "8.3333%" }}
          className="col-5 flex justify-content-center"
        >
          VARIABLE
        </div>
        <div className="col-5 flex justify-content-center">VALEUR</div>
      </div>
      {mapWidget &&
        mapWidget.map((item, index) => (
          <div className="grid" key={item.id}>
            <div className="col-1 flex jusfiy-content-center align-items-center">
              <img
                alt={item.type}
                src={CorrespondanceTypeImage(item.type)}
                className="mr-2"
                style={{
                  width: "2rem",
                  height: "1.5rem",
                  backgroundColor: "#f0f3f5",
                }}
              />
            </div>
            <div className="col-5">
              <InputText
                value={item.key}
                className="w-full h-full"
                disabled={disabled}
                onChange={(e) => {
                  udpateItem(index, {
                    id: item.id,
                    key: e.target.value,
                    value: item.value,
                    type: item.type,
                  });
                }}
              />
            </div>
            <div className="col-5 flex justify-content-center align-items-center">
              <FieldType
                onChange={(value: any) => {
                  udpateItem(index, {
                    id: item.id,
                    key: item.key,
                    value: value,
                    type: item.type,
                  });
                }}
                type={item.type}
                value={item.value}
                disabled={disabled}
              ></FieldType>
            </div>
            <div className="col-1 cross">
              {!disabled &&
                <FontAwesomeIcon
                  className="icon"
                  icon={"xmark"}
                  onClick={() => {
                    deleteItem(index);
                  }}
                />
              }
            </div>
          </div>
        ))}
        {!disabled &&
          <>
            <div className="mt-3">Ajout d'une nouvelle entrée :</div>
            <div className="mt-1 grid">
              <div className="col-11 pl-0">
                <Dropdown
                  value={valueType}
                  onChange={(e) => {
                    setValueTypes(e.value);
                  }}
                  options={types}
                  optionLabel="name"
                  placeholder="Type de la valeur"
                  itemTemplate={TypesOptionTemplate}
                  valueTemplate={selectedTypesTemplate}
                />
              </div>
              <div className="col-1 cross">
              <FontAwesomeIcon
                      className="icon"
                      icon={"plus"}
                      onClick={() => {
                        addItem()
                      }}
                    />
              </div>
            </div>
          </>
        }
    </div>
  );
};
